<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  computed: {
    userInfo () {
      return this.$store.state.userInfo
    }
  },
  created () {}
}
</script>

<style lang="sass">
#app
  color: #2c3e50;
html, body, #app
  height: 100%;
  width: 100%;
  font-size: 14px;
</style>



// WEBPACK FOOTER //
// App.vue?34a3605c